
import { Component, Mixins } from 'vue-property-decorator';
import {
    addStreamCondition,
    editStreamCondition,
} from '@/api/uapi';
import { showServerError } from '@/utils';
import ConditionContent from '@/components/uapi/conditions/ConditionContent.vue';
import ConditionGeo from '@/components/uapi/conditions/ConditionGeo.vue';
import StatsCard from '@/components/base/StatsCard.vue';
import TooltipButton from '@/components/base/buttons/TooltipButton.vue';
import StreamCondition from "@/mixins/streamCondition";

@Component({
    components: {
        ConditionContent,
        ConditionGeo,
        TooltipButton,
        StatsCard,
    },
})
export default class ConditionStream extends Mixins(StreamCondition) {
    isBtnLoading = false;

    async saveCondition(): Promise<void> {
        const streamCondition: any = this.getConditionsToSend();
        this.isBtnLoading = true;
        const { streamId } = this.$route.params;
        try {
            if (this.condition!.id) {
                await editStreamCondition(streamId, this.condition!.id, streamCondition!);
            } else {
                const { data } = await addStreamCondition(streamId, streamCondition!);
                this.condition = data;
                await this.$router.push({ name: 'stream-edit', params: { streamId: this.$route.params.streamId } });
            }
        } catch (err) {
            showServerError(err);
        } finally {
            this.isBtnLoading = false;
        }
    }
}
